import React, { useState } from "react";
import { Animate } from "react-simple-animate";

function VideoModal(props) {

    const {vidLink, orientation} = props;
    const [modal, setModal] = useState(false);

    const newLink = (vidLink && vidLink.replace("watch?v=", "embed/"))

    const openModal = () => {
        setModal(!modal);
    };

    return (


            <div onClick={openModal} className={"flex items-center justify-center h-full"}>
                <div className={`h-16 w-16 rounded-full flex items-center justify-center cursor-pointer bg-gold-accent bg-pink-icon/75`}>
                    <i className="ri-play-line text-3xl text-purple-dashboard  flex items-center justify-center h-12 w-12"></i>
                </div>

                {modal ? (
                    <Animate play start={{ opacity: 0 }}  end={{ opacity: 1 }} duration={0.7}>
                        <section className="modal__bg fixed top-0 left-0 w-full h-full z-40 bg-black/60">
                            <div className="modal__align flex justify-center items-center h-screen">
                                <div className="w-11/12 md:w-9/12 xl:w-8/12 ">
                                    <div className={"flex justify-end pb-12"}>
                                        <div className="modal__close text-gold-accent  cursor-pointer  text-2xl"
                                           arial-label="Close modal"
                                           onClick={setModal}
                                        >
                                            X
                                        </div>
                                    </div>
                                    <div className="modal__video-align flex relative bottom-8">

                                        {/*<iframe*/}
                                        {/*    className="modal__video-style rounded-xl z-50 aspect-video w-full"*/}
                                        {/*    src={newLink}*/}
                                        {/*    title="YouTube video player"*/}
                                        {/*    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"*/}
                                        {/*    allowFullScreen*/}
                                        {/*></iframe>*/}

                                        {/*<iframe*/}
                                        {/*    className="modal__video-style rounded-xl z-50 aspect-video w-full"*/}
                                        {/*    src={`https://vimeo.com/747306983/53a52e7293`}*/}
                                        {/*    title="Vimeo video player"*/}
                                        {/*    allow="allowFullScreen"*/}
                                        {/*    allowFullScreen*/}
                                        {/*></iframe>*/}

                                        {vidLink && vidLink.includes("player.vimeo.com") &&
                                            <iframe
                                                // className={` modal__video-style rounded-xl z-50 aspect-video w-full `}
                                                className = { ` modal__video-style cursor-pointer  rounded-xl z-50 w-full h-164 ${orientation === 'landscape' ? ' aspect-video w-full ' : orientation === 'portrait' ? ' aspect-portrait ' : ''} ` }
                                                title="vimeo-player"
                                                src={vidLink}
                                                // width="640"
                                                // height="360"
                                                allowFullScreen>
                                            </iframe>
                                        }

                                        {vidLink && !vidLink.includes("player.vimeo.com") &&
                                            <iframe
                                                className="modal__video-style rounded-xl z-50 aspect-video w-full cursor-pointer"
                                                src={newLink}
                                                title="YouTube video player"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                                allowFullScreen
                                            />




                                        }
                                    </div>
                                </div>
                            </div>
                        </section>
                    </Animate>
                ) : null}
            </div>

    );
}

export default VideoModal;
